(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '../assets/styles/components/Filters.scss';
import Loading from '../components/custom/Loading';
import Filters from '../components/Filters';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ItemProperty from '../components/ItemProperty';
import ScrollToTop from '../components/scroll-to-top';
import { listSearchRequest } from '../redux/actions/searchActions';
import { getQuery, SEARCH_REGEX } from '../utils/utilities';
const searchPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'SearchResultsPage',
  name: 'Search USC Off-Campus Apartments — Community Builders Management',
  description: 'Browse all owner-managed USC student apartments by price, bedrooms, and community. Filter by floor plan and find your ideal off-campus housing near USC.',
  url: 'https://livecbm.com/search',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Community Builders Management',
    url: 'https://livecbm.com/',
    telephone: '+18006043430'
  },
  about: {
    '@type': 'ItemList',
    name: 'USC Student Housing Communities',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'The Arches — 1229 W. 37th Place, Los Angeles, CA 90007',
      url: 'https://livecbm.com/building-details/usc-student-housing-the-arches-1229-w-37th-place-los-angeles-ca-90007'
    }, {
      '@type': 'ListItem',
      position: 2,
      name: 'The Bryce — 1287 W. 37th Place, Los Angeles, CA 90007',
      url: 'https://livecbm.com/building-details/usc-student-housing-the-bryce-1287-w-37th-place-los-angeles-ca-90007'
    }, {
      '@type': 'ListItem',
      position: 3,
      name: 'The Cascades — 1136 W. 36th St, Los Angeles, CA 90007',
      url: 'https://livecbm.com/building-details/usc-student-housing-the-cascades-1136-w-36th-st-los-angeles-ca-90007'
    }, {
      '@type': 'ListItem',
      position: 4,
      name: 'The Olympic — 1234 W. 37th Place, Los Angeles, CA 90007',
      url: 'https://livecbm.com/building-details/usc-student-housing-the-olympic-1234-w-37th-place-los-angeles-ca-90007'
    }, {
      '@type': 'ListItem',
      position: 5,
      name: 'The Redwood — 1216 W. 37th Place, Los Angeles, CA 90007',
      url: 'https://livecbm.com/building-details/usc-student-housing-the-redwood-1216-w-37th-place-los-angeles-ca-90007'
    }, {
      '@type': 'ListItem',
      position: 6,
      name: 'The Sequoia — 1222 W. 37th Place, Los Angeles, CA 90007',
      url: 'https://livecbm.com/building-details/usc-student-housing-the-sequoia-1222-w-37th-place-los-angeles-ca-90007'
    }, {
      '@type': 'ListItem',
      position: 7,
      name: 'Avalon — 1248 W. Adams Blvd., Los Angeles, CA 90007',
      url: 'https://livecbm.com/building-details/usc-student-housing-avalon-1248-w-adams-blvd-los-angeles-ca-90007'
    }]
  }
};
class FindHosuing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    // this.handleUrlChange = this.handleUrlChange.bind(this);
    this.params = this.props.match.params;
  }

  // handleUrlChange(event) {
  //   // console.log('event :>> ', event);
  // }

  // getPageUrlAll() {
  //   const query = getQuery(this.props.location) || {};

  //   query.page = 'all';

  //   const queryParams = `?${Object.keys(query)
  //     .map((key) => `${key}=${query[key]}`)
  //     .join('&')}`;

  //   const url = this.props.location.pathname + queryParams;
  //   return url;
  // }

  async loadData() {
    // console.log('loadData find housing');
    try {
      const {
        page
      } = getQuery(this.props.location) || {};
      // console.log('page :>> ', page);
      if (!page) {
        // console.log('loadData page', page);
        const url = this.props.location.pathname.replace(SEARCH_REGEX, '') + this.props.location.search;
        const backToResult = this.props.location.pathname + this.props.location.search;
        // console.log('Back to result', backToResult);
        this.props.listSearchRequest(url, backToResult);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  componentDidMount() {
    // console.log('this.props', this.props);
    // console.log('componentDidMount find housing');
    // console.log('history.action', this.props.history.action);
    if (this.props.history.action !== 'POP') {
      this.loadData();

      // this.loadData();
    } else if (!this.props.search.SSR) {
      this.loadData();
    } else this.props.search.SSR = false;
  }
  componentWillUnmount() {
    // console.log('componentWillUnmount :>> ');
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname || prevProps.location.search !== this.props.location.search) {
      if (SEARCH_REGEX.test(this.props.location.pathname)) {
        // console.log('prevProps.location.pathname', prevProps.location.pathname);
        // console.log('this.props.location.pathname', this.props.location.pathname);
        // console.log('prevProps.location.search', prevProps.location.search);
        // console.log(' this.props.location.search', this.props.location.search);
        this.loadData();
      }
    }
  }
  render() {
    // if (this.props.search.list.length === 0) {
    //   return <Loading />;
    // }
    const {
      data,
      communities,
      floorplans,
      rents
    } = this.props.search.list;
    // const datafinal = data && data.filter((item) => item.units.length > 0);
    const datafinal = data;
    // console.log("Mira la info",datafinal)
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "USC Off-Campus Apartments \u2014 Search All Communities | CBM"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "Search owner-managed USC student housing by price, bedrooms, and community. Studios to 5BR \u2014 all within the DPS patrol zone & Fryft boundary. Filter and tour today."
    }), /*#__PURE__*/React.createElement("script", {
      type: "application/ld+json"
    }, JSON.stringify(searchPageSchema)), /*#__PURE__*/React.createElement("meta", {
      name: "keywords",
      content: "USC off-campus apartments, student apartments near USC, USC housing search, find apartment near USC, USC off campus housing fall 2026"
    }), /*#__PURE__*/React.createElement("meta", {
      name: "keywords",
      content: "studio apartments near USC, 1 bedroom apartment USC, 4 bedroom houses near USC, furnished off campus apartments USC, pet friendly student housing USC"
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement("main", {
      id: "content",
      className: "bypass-block-target main-content main-content--find-housing container padding-bottom-inner",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement("section", {
      className: "search-intro-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-intro-wrap__inner"
    }, /*#__PURE__*/React.createElement("section", {
      className: "search-intro"
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-intro__media"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/people.png",
      alt: "Students looking for USC off-campus apartments",
      className: "search-intro__image",
      width: "600",
      height: "450",
      loading: "lazy"
    })), /*#__PURE__*/React.createElement("div", {
      className: "search-intro__content"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h2 search-intro__title"
    }, "FIND YOUR USC OFF-CAMPUS APARTMENT", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      className: "h1__span"
    }, "ALL CBM COMMUNITIES")), /*#__PURE__*/React.createElement("p", {
      className: "search-intro__text"
    }, /*#__PURE__*/React.createElement("strong", null, "Searching for USC off-campus housing for fall 2026?"), " You're in the right place. Community Builders Management offers eight owner-operated student apartment communities across University Park, North University Park, and West Adams - all within the 90007 zip code, all inside the USC DPS patrol zone, and all within the USC Fryft boundary."), /*#__PURE__*/React.createElement("p", {
      className: "search-intro__text"
    }, "Use the filters below to narrow your search by price range, floor plan, and community. Every listing includes photos, square footage, floor plan details, and current pricing - so you can shortlist your favorites before scheduling an in-person tour. Tours are available seven days a week at your convenience."), /*#__PURE__*/React.createElement("p", {
      className: "search-intro__text"
    }, /*#__PURE__*/React.createElement("strong", null, "Not sure what you're looking for?"), " Call or text (800) 604-3430 and a CBM leasing specialist will match you with the right unit for your budget and group size."))))), /*#__PURE__*/React.createElement(Filters, {
      mode: "page",
      style: {
        marginTop: '0.25rem !important'
      }
      // handleUrlChange={this.handleUrlChange}
      // communities={communities}
      // floorplans={floorplans}
      // rents={rents}
    }), this.props.search.loading ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(ItemProperty, {
      data: datafinal,
      params: this.params,
      pushToSearch: true
    }), /*#__PURE__*/React.createElement("section", {
      className: "search-howto-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-howto-wrap__inner"
    }, /*#__PURE__*/React.createElement("section", {
      className: "search-howto"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "h2 text-center search-howto__title"
    }, /*#__PURE__*/React.createElement("span", {
      className: "h1__span"
    }, "HOW TO SEARCH FOR"), /*#__PURE__*/React.createElement("br", null), "USC STUDENT HOUSING ON THIS PAGE"), /*#__PURE__*/React.createElement("p", {
      className: "text-center search-howto__intro"
    }, "Finding the right USC off-campus apartment is about matching four things: your budget, your group size, your walk-to-campus priority, and your lifestyle preferences. Here is how to use this page to narrow it down quickly."), /*#__PURE__*/React.createElement("div", {
      className: "search-howto__grid"
    }, /*#__PURE__*/React.createElement("article", {
      className: "search-howto-card"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/01.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-howto-card__icon",
      width: "42",
      height: "42",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "search-howto-card__title"
    }, "Filter by Price Range"), /*#__PURE__*/React.createElement("p", {
      className: "search-howto-card__text"
    }, "CBM's portfolio runs from $1,900/mo (studio) to $5,300/mo (5-bedroom shared house). If you are splitting rent with roommates, look at the per-person cost rather than the total.")), /*#__PURE__*/React.createElement("article", {
      className: "search-howto-card"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/02.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-howto-card__icon",
      width: "42",
      height: "42",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "search-howto-card__title"
    }, "Filter by Bedrooms"), /*#__PURE__*/React.createElement("p", {
      className: "search-howto-card__text"
    }, "Solo renter? Filter for Studio or 1-Bed. Roommate pair? Try 2 Bed. Coming with a group of 3-5? The 3BR, 4BR, and 5BR options across The Cascades, The Sequoia, and The Arches are the most popular group configurations.")), /*#__PURE__*/React.createElement("article", {
      className: "search-howto-card"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/03.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-howto-card__icon",
      width: "42",
      height: "42",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "search-howto-card__title"
    }, "Filter by Community"), /*#__PURE__*/React.createElement("p", {
      className: "search-howto-card__text"
    }, "All CBM communities are within walking distance of USC, but their exact positions vary. Properties on W. 37th Place are generally the closest to USC's main McCarthy Way entrance.")), /*#__PURE__*/React.createElement("article", {
      className: "search-howto-card"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/04.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-howto-card__icon",
      width: "42",
      height: "42",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "search-howto-card__title"
    }, "Schedule a Tour"), /*#__PURE__*/React.createElement("p", {
      className: "search-howto-card__text"
    }, "Once you shortlist your communities, click any property card to see the full floor plan gallery and pricing details. From there, submit a Guest Card directly or call (800) 604-3430 to book a walk-through.")))))), /*#__PURE__*/React.createElement("section", {
      className: "search-reasons-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-reasons-wrap__inner"
    }, /*#__PURE__*/React.createElement("section", {
      className: "search-reasons"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "h2 text-center search-reasons__title"
    }, "WHY RENT WITH COMMUNITY ", /*#__PURE__*/React.createElement("span", {
      className: "h1__span"
    }, "BUILDERS MANAGEMENT?")), /*#__PURE__*/React.createElement("p", {
      className: "text-center search-reasons__intro"
    }, /*#__PURE__*/React.createElement("strong", null, "CBM is not a faceless management company"), " - we are the owners. Every property in our portfolio is directly owned and managed by the same team, which means faster maintenance response, a personal relationship with ownership, and a genuine investment in building community within each building."), /*#__PURE__*/React.createElement("h3", {
      className: "text-center search-reasons__subtitle"
    }, "KEY REASONS USC STUDENTS AND PARENTS", ' ', /*#__PURE__*/React.createElement("span", {
      className: "h1__span"
    }, "CHOOSE CBM YEAR AFTER YEAR:")), /*#__PURE__*/React.createElement("div", {
      className: "search-reasons__grid"
    }, /*#__PURE__*/React.createElement("article", {
      className: "search-reason-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/check_circle.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-reason-item__icon",
      width: "28",
      height: "28",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "search-reason-item__text"
    }, "All properties within the USC DPS yellow-jacket patrol zone")), /*#__PURE__*/React.createElement("article", {
      className: "search-reason-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/check_circle.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-reason-item__icon",
      width: "28",
      height: "28",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "search-reason-item__text"
    }, "Updated appliances, security cameras, and exterior lighting at every property")), /*#__PURE__*/React.createElement("article", {
      className: "search-reason-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/check_circle.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-reason-item__icon",
      width: "28",
      height: "28",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "search-reason-item__text"
    }, "All properties within the Fryft (Free Lyft) boundary")), /*#__PURE__*/React.createElement("article", {
      className: "search-reason-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/check_circle.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-reason-item__icon",
      width: "28",
      height: "28",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "search-reason-item__text"
    }, "In-person tours available 7 days a week")), /*#__PURE__*/React.createElement("article", {
      className: "search-reason-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/check_circle.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-reason-item__icon",
      width: "28",
      height: "28",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "search-reason-item__text"
    }, "Owner-managed - not outsourced to a third-party property manager")), /*#__PURE__*/React.createElement("article", {
      className: "search-reason-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/search/check_circle.svg",
      alt: "",
      "aria-hidden": "true",
      className: "search-reason-item__icon",
      width: "28",
      height: "28",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "search-reason-item__text"
    }, "USC Roommate Finder available on-site for students building their group"))))))), /*#__PURE__*/React.createElement(Footer, null));
  }
  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }
}
const mapStateToProps = ({
  search
}) => ({
  search
});
const mapDispatchToProps = {
  listSearchRequest
};
const _default = withRouter(connect(mapStateToProps, mapDispatchToProps)(FindHosuing));
export default _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(searchPageSchema, "searchPageSchema", "/var/www/html/websites/livecbm-com/src/frontend/pages/FindHosuing.jsx");
  reactHotLoader.register(FindHosuing, "FindHosuing", "/var/www/html/websites/livecbm-com/src/frontend/pages/FindHosuing.jsx");
  reactHotLoader.register(mapStateToProps, "mapStateToProps", "/var/www/html/websites/livecbm-com/src/frontend/pages/FindHosuing.jsx");
  reactHotLoader.register(mapDispatchToProps, "mapDispatchToProps", "/var/www/html/websites/livecbm-com/src/frontend/pages/FindHosuing.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/livecbm-com/src/frontend/pages/FindHosuing.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();